import React, { useEffect, useState } from "react";
import { FaHashtag, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { ComplateRunningreport } from "../../Redux/Slice/Day";
import defaultProfile from "../../Image/Daynamic_Logo_Piture.png";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader/Loader";

/* ========================= TASK CARD ========================= */

const TaskCard = ({ user }) => {
  const [queueExpanded, setQueueExpanded] = useState(false);
  const [holdExpanded, setHoldExpanded] = useState(false);
  const navigate = useNavigate();

  const mapUserToTaskData = (user) => {
    if (!user) return null;

    const queueTasks = user.TaskId?.filter((t) => t.Status === "Pending") || [];
    const runningTasks =
      user.TaskId?.filter((t) => t.Status === "Running") || [];
    const acceptTasks = user.Accept?.filter((t) => t.Status === "Accept") || [];
    const holdTasks = user.Hold || [];
    const pendingTasks = user.Pending || [];

    // Priority → Accept > Running
    const activeRunning =
      acceptTasks.length > 0
        ? acceptTasks[0]
        : runningTasks.length > 0
          ? runningTasks[0]
          : null;

    return {
      id: user._id,
      name: user.Name,
      role: user.Role || "Team Member",
      avatar: user.ProfilePhoto,

      stats: {
        queue: queueTasks.length + pendingTasks.length,
        running: acceptTasks.length + runningTasks.length,
        hold: holdTasks.length,
      },

      running: activeRunning
        ? {
            callNo: activeRunning.CallNo,
            companyName: activeRunning.CompanyName,
            fullData: activeRunning,
            taskId: activeRunning._id,
            complainId: activeRunning.ConplainId || activeRunning._id,
          }
        : null,

      queue: [
        ...queueTasks.map((task) => ({
          id: task.CallNo,
          status: task.Status,
          taskId: task._id,
          complainId: task.ConplainId || task._id,
        })),
        ...pendingTasks.map((task) => ({
          id: task.CallNo,
          status: "Pending",
          taskId: task._id,
          complainId: task.ConplainId || task._id,
        })),
      ],

      hold: holdTasks.map((task) => ({
        id: task.CallNo || task._id?.slice(-4),
        taskId: task._id,
        complainId: task.ConplainId || task._id,
      })),
    };
  };

  const taskData = mapUserToTaskData(user);
  if (!taskData) return null;

  // Get visible items (max 2 per row)
  const getVisibleItems = (items, isExpanded) => {
    if (isExpanded) return items;
    return items.slice(0, 2);
  };

  // Function to handle click on any task - opens in new tab
  const handleTaskClick = (taskId, complainId) => {

    // Create the URL
    let url = "";
    // Priority 1: Use complainId if available
    if (complainId) {
      url = `/TaskReport/CustomerrequustDetail/${complainId}`;
    }
    // Priority 2: Use taskId as fallback
    else if (taskId) {
      url = `/TaskReport/CustomerrequustDetail/${taskId}`;
    }

    if (url) {
      // Open in new tab
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  // Function to handle button click (for the show more/show less buttons)
  const handleButtonClick = (e, callback) => {
    e.preventDefault();
    e.stopPropagation();
    callback();
  };

  return (
    <div className="bg-white rounded-2xl shadow-lg p-5 border border-gray-200">
      {/* HEADER */}
      <div className="flex items-center gap-3 mb-4">
        <img
          src={taskData.avatar || defaultProfile}
          alt="profile"
          className="w-11 h-11 rounded-full object-cover"
          onError={(e) =>
            (e.target.src = "https://via.placeholder.com/44?text=User")
          }
        />
        <div>
          <h2 className="font-semibold text-[#112A47]">{taskData.name}</h2>
          <p className="text-sm text-[#112A47]">{taskData.role}</p>
        </div>
      </div>

      {/* STATS */}
      <div className="flex gap-2 mb-4 flex-wrap">
        <span className="px-3 py-1 text-sm rounded-full bg-blue-100 text-blue-700">
          {taskData.stats.queue} Queue
        </span>
        <span className="px-3 py-1 text-sm rounded-full bg-green-100 text-green-700">
          {taskData.stats.running} Running
        </span>
        <span className="px-3 py-1 text-sm rounded-full bg-orange-100 text-orange-700">
          {taskData.stats.hold} Hold
        </span>
      </div>

      {/* RUNNING / ACCEPT */}
      <div className="mb-4">
        <h3 className="text-sm font-semibold mb-2 text-[#112A47]">
          ● RUNNING / ACCEPT
        </h3>

        {taskData.running ? (
          <div
            className="bg-green-100 rounded-lg p-3 border border-green-200 cursor-pointer hover:bg-green-200 transition-colors"
            onClick={() =>
              handleTaskClick(
                taskData.running.taskId,
                taskData.running.complainId,
              )
            }
          >
            <div className="flex items-center gap-1 text-green-700 font-semibold">
              <FaHashtag size={12} className="inline" />
              <span>{taskData.running.callNo}</span>
            </div>
            <p className="text-xs text-gray-800 mt-1 truncate">
              {taskData.running.companyName}
            </p>
          </div>
        ) : (
          <div className="bg-green-100 rounded-lg p-3 text-center text-[#112A47] text-sm">
            No running task
          </div>
        )}
      </div>

      {/* QUEUE */}
      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-semibold text-gray-700">
            ● QUEUE ({taskData.queue.length})
          </h3>
          {taskData.queue.length > 2 && (
            <button
              onClick={(e) =>
                handleButtonClick(e, () => setQueueExpanded(!queueExpanded))
              }
              className="text-xs text-blue-600 flex items-center gap-1 hover:text-blue-800"
            >
              {queueExpanded ? (
                <>
                  <span>Show Less</span>
                  <FaChevronDown size={10} />
                </>
              ) : (
                <>
                  <span>Show More</span>
                  <FaChevronRight size={10} />
                </>
              )}
            </button>
          )}
        </div>

        {taskData.queue.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {getVisibleItems(taskData.queue, queueExpanded).map(
              (task, index) => (
                <div
                  key={index}
                  className="bg-blue-500 text-white rounded-lg p-2 min-w-[70px] text-center text-xs flex items-center justify-center cursor-pointer hover:bg-blue-600 transition-colors"
                  onClick={() => handleTaskClick(task.taskId, task.complainId)}
                  title={`Call No: ${task.id}\nClick to view details`}
                >
                  <FaHashtag size={10} className="inline mr-1" /> {task.id}
                </div>
              ),
            )}
          </div>
        ) : (
          <div className="bg-blue-100 rounded-lg p-3 text-center text-[#112A47] text-sm">
            No queue
          </div>
        )}
      </div>

      {/* HOLD */}
      <div>
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-semibold text-gray-700">
            ● HOLD ({taskData.hold.length})
          </h3>
          {taskData.hold.length > 2 && (
            <button
              onClick={(e) =>
                handleButtonClick(e, () => setHoldExpanded(!holdExpanded))
              }
              className="text-xs text-orange-600 flex items-center gap-1 hover:text-orange-800"
            >
              {holdExpanded ? (
                <>
                  <span>Show Less</span>
                  <FaChevronDown size={10} />
                </>
              ) : (
                <>
                  <span>Show More</span>
                  <FaChevronRight size={10} />
                </>
              )}
            </button>
          )}
        </div>

        {taskData.hold.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {getVisibleItems(taskData.hold, holdExpanded).map((task, index) => (
              <div
                key={index}
                className="bg-orange-500 text-white rounded-lg p-2 min-w-[70px] text-center text-xs flex items-center justify-center cursor-pointer hover:bg-orange-600 transition-colors"
                onClick={() => handleTaskClick(task.taskId, task.complainId)}
                title={`Call No: ${task.id}\nClick to view details`}
              >
                <FaHashtag size={10} className="inline mr-1" /> {task.id}
              </div>
            ))}
          </div>
        ) : (
          <div className="bg-orange-100 rounded-lg p-3 text-center text-[#112A47] text-sm">
            No hold tasks
          </div>
        )}
      </div>
    </div>
  );
};

/* ========================= TASK DETAIL ========================= */

const TaskDetail = () => {
  const dispatch = useDispatch();
  const [usersData, setUsersData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(ComplateRunningreport()).then((res) => {
      console.log("API Response:", res?.payload?.data);
      if (res?.payload?.data) {
        setUsersData(res.payload.data);
      }
      setLoading(false);
    });
  }, [dispatch]);

  // Show loader while loading
  if (loading) return <Loader />;

  // Calculate totals
  const totalQueue = usersData.reduce(
    (sum, u) =>
      sum +
      (u.TaskId?.filter((t) => t.Status === "Pending").length || 0) +
      (u.Pending?.length || 0),
    0,
  );

  const totalRunning = usersData.reduce(
    (sum, u) =>
      sum +
      (u.Accept?.length || 0) +
      (u.TaskId?.filter((t) => t.Status === "Running").length || 0),
    0,
  );

  const totalHold = usersData.reduce(
    (sum, u) => sum + (u.Hold?.length || 0),
    0,
  );

  return (
    <div>
      {/* Title */}
      <h3 className="text-xl mb-3 font-bold main_title_page text-white px-4 py-2 inline-block rounded">
        EMP Task Detail
      </h3>
      {/* OVERVIEW */}
      <div className="mb-6 p-4 bg-white rounded-2xl shadow border">
        <h2 className="text-xl font-bold mb-4">Team Overview</h2>

        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
          <div className="p-4 bg-blue-100 rounded">
            <p className="text-[#112A47] font-medium">Total Members</p>
            <p className="text-2xl font-bold text-gray-800">
              {usersData.length}
            </p>
          </div>

          <div className="p-4 bg-green-100 rounded">
            <p className="text-[#112A47] font-medium">Running / Accept</p>
            <p className="text-2xl font-bold text-gray-800">{totalRunning}</p>
          </div>

          <div className="p-4 bg-orange-100 rounded">
            <p className="text-[#112A47] font-medium">Hold</p>
            <p className="text-2xl font-bold text-gray-800">{totalHold}</p>
          </div>

          <div className="p-4 bg-blue-100 rounded">
            <p className="text-[#112A47] font-medium">Queue</p>
            <p className="text-2xl font-bold text-gray-800">{totalQueue}</p>
          </div>
        </div>
      </div>

      {/* CARDS */}
      {usersData.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {usersData.map((user) => (
            <TaskCard key={user._id} user={user} />
          ))}
        </div>
      ) : (
        <div className="bg-white rounded-2xl shadow border p-8 text-center">
          <p className="text-gray-500 text-lg">No team members found</p>
          <p className="text-gray-400 text-sm mt-2">No data available</p>
        </div>
      )}
    </div>
  );
};

export default TaskDetail;
